/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you are an app developer and requires the theme to re-render the mini-cart, you can trigger your own event. If
 * you are adding a product, you need to trigger the "product:added" event, and make sure that you pass the quantity
 * that was added so the theme can properly update the quantity:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('product:added', {
 *   bubbles: true,
 *   detail: {
 *     quantity: 1
 *   }
 * }));
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

(function() {
  function injectStyle(shadowRoot) {
    var style = document.createElement('style');
    style.textContent = '#gw-tabcontrol-rv-widget-layout-tab-questions { display: none !important; } button.gw-btn--mode-secondary.gw-btn--size-small[aria-haspopup="dialog"] { display: none !important; }';
    shadowRoot.appendChild(style);
  }

  function checkShadowRoots() {
    document.querySelectorAll('*').forEach(function(el) {
      if (el.shadowRoot && !el.dataset.gwStyled) {
        el.dataset.gwStyled = '1';
        injectStyle(el.shadowRoot);
      }
    });
  }

  var observer = new MutationObserver(checkShadowRoots);
  observer.observe(document.body, { childList: true, subtree: true });
  checkShadowRoots();
})();

/* =========================================
 * OPENキャンペーン
 * 10%OFF + 送料無料クーポンを同時適用
 * ========================================= */
(function () {
  'use strict';

  // 10%OFFクーポン
  const DISCOUNT_CODE = 'OPENCP';

  // 送料無料クーポン
  const FREE_SHIPPING_CODE = 'OPENCPFREE';

  // 連打による二重処理防止
  let isApplying = false;


  /**
   * Shopify Cart Ajax API のURLを取得
   */
  function getCartUpdateUrl() {
    const root =
      (window.routes && window.routes.rootUrl) ||
      (
        window.Shopify &&
        window.Shopify.routes &&
        window.Shopify.routes.root
      ) ||
      '/';

    const normalizedRoot = root.endsWith('/')
      ? root
      : `${root}/`;

    return `${normalizedRoot}cart/update.js`;
  }


  /**
   * discount URL の redirect パラメータを取得
   */
  function getRedirectUrl(discountUrl) {
    const redirect =
      discountUrl.searchParams.get('redirect') || '/';

    try {
      const redirectUrl = new URL(
        redirect,
        window.location.origin
      );

      // 外部サイトへのredirectは許可しない
      if (
        redirectUrl.origin !==
        window.location.origin
      ) {
        return '/';
      }

      return (
        redirectUrl.pathname +
        redirectUrl.search +
        redirectUrl.hash
      );
    } catch (error) {
      return '/';
    }
  }


  document.addEventListener(
    'click',
    async function (event) {

      // OPENキャンペーンLPだけで実行
      if (
        !document.body.classList.contains(
          'page--open-cp'
        )
      ) {
        return;
      }

      // event.target がElementでない場合の対策
      if (!(event.target instanceof Element)) {
        return;
      }

      const link =
        event.target.closest('a[href]');

      if (!link) {
        return;
      }

      let url;

      try {
        url = new URL(
          link.href,
          window.location.href
        );
      } catch (error) {
        return;
      }

      // /discount/OPENCP のリンクだけ対象
      if (
        url.pathname.replace(/\/$/, '') !==
        `/discount/${DISCOUNT_CODE}`
      ) {
        return;
      }

      event.preventDefault();

      // 処理中なら何もしない
      if (isApplying) {
        return;
      }

      isApplying = true;

      const redirectUrl =
        getRedirectUrl(url);

      try {

        const response = await fetch(
          getCartUpdateUrl(),
          {
            method: 'POST',

            credentials: 'same-origin',

            headers: {
              'Content-Type': 'application/json',
              'Accept': 'application/json'
            },

            body: JSON.stringify({
              discount:
                `${DISCOUNT_CODE},${FREE_SHIPPING_CODE}`
            })
          }
        );

        if (!response.ok) {
          throw new Error(
            `Cart update failed: ${response.status}`
          );
        }

        // 2つのクーポン設定完了後、
        // 元々指定されていたredirect先へ移動
        window.location.assign(
          redirectUrl
        );

      } catch (error) {

        console.error(
          '[OPEN CP] Failed to apply discounts:',
          error
        );

        // エラー時は遷移させない
        // 10%OFFだけ適用される状態を防ぐ
        isApplying = false;
      }
    }
  );

})();